import { render, staticRenderFns } from "./reviewTableV2.vue?vue&type=template&id=4dc9315a&scoped=true"
import script from "./reviewTableV2.vue?vue&type=script&lang=js"
export * from "./reviewTableV2.vue?vue&type=script&lang=js"
import style0 from "./reviewTableV2.vue?vue&type=style&index=0&id=4dc9315a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc9315a",
  null
  
)

export default component.exports